<template>
	<div>
		<h1 v-on:click="$router.push('/editors/create/' + componentType)">Create New : {{componentType}}</h1>
		<table v-if="components">
			<thead>
				<tr>
					<th scope="row">ID</th>
					<th>Title</th>
					<th>Thumbnail</th>
					<th>View</th>
					<th>Edit</th>
					<!-- <th>Disable</th> -->
				</tr>
			</thead>
			<tbody>
      <!--|| (comp.ContentType == componentType)-->
				<tr v-for="(comp, i) in components" v-if="(comp.Featured == true && componentType == 'Featured') || (comp.Component == componentType) || (comp.Component == componentType.toLowerCase())" :key="'LINE-' + i">
					<td>{{ comp.ID }}</td>
					<td>{{ comp.Title }}</td>
					<td><img :src="comp.Thumbnail"></td>
					<td><button v-on:click="actionView(comp.ID,comp)" class="primary">View</button></td>
					<td><button v-on:click="actionEdit(comp.ID)" class="warning">Edit</button></td>
					<!-- <td><button v-on:click="actionDisable(comp.ID)" class="danger">Disable</button></td> -->
				</tr>
			</tbody>
		</table>
	</div>
</template>
<style type="text/css" scoped>
	h1{
		text-align: center;
		padding: 1.5em;
		border-radius: 10px 10px 0 0;
		background: #121212;
		cursor: pointer;
		transition: all 0.5s ease;
		margin-bottom: 0;
	}
	h1:hover{
		background: #434343;
	}
	table{
		width: 100%;
		border-right: 1px solid black;
		text-align: center;
	}
	thead{
		font-size: 1.4em;
		background: #404040;
	}
	th{
		padding-top: 1em;
		padding-bottom: 1em;
	}
	th,td{
		border-left: 1px solid white;
		border-bottom: 1px solid white;
	}
  td{
    border-left: 1px solid black;
    border-bottom: 1px solid black; 
    color: black;
  }
	table img{
		height: 100px;
	}
	button.primary{
		background: #007bff;
		color: white;
	}
	button.warning{
		background: #fd7e14;
		color: white;
	}
	button.danger{
		background: #dc3545;
		color: white;
	}
</style>

<script type="text/javascript">
	import { ajaxGet,ajaxPost } from "../ajax";
  import {apiUrl} from "@/main";

	export default{
		props: ['componentType'],
		data: function(){
			return {
				components: []
			}
		},
		mounted: function(){
			console.clear();
      //this.componentType.toUpperCase()
        ajaxGet(apiUrl() +"/content?Component=" + this.componentType + "&editable=true",
            (data) => {
          //console.log(data);
              this.components = data;
            },(err) => {
              console.log("ERROR OCCURED:", err);
            },localStorage.token);
		},
		methods: {
			actionView: function(id,comp) {
				console.log("VIEW", id);
        if(this.componentType == "Featured")
        {
          alert("Can't click here for now");
        }
        else if(this.componentType == "pdf") {
           window.location.href = "/BookViewer/web/viewer.html?file=" + btoa(comp.Location).replace('/', '_').replace('+', '-');
        }
        else
        {
          window.open("/#/interactive/" + this.componentType + "/" + id);
        }
			},
			actionEdit: function(id) {
				//console.log("EDIT", id);
        window.open("/#/editors/edit/" + this.componentType + "/" + id);
			},
			actionDisable: function(id) {
				//console.log("DELETE", id);
			}
		}
	};
</script>